module.exports = __webpack_public_path__ + "img/prop.d6756739.png";